<template>
  <v-content>
    <v-container fluid>
      <Header :title="title" />
      <v-row no-gutters>
        <v-col cols="12">
          <DataTable
            @editing="editing"
            @deleting="deleting"
            :title="''"
            :headers="headers"
            :items="questions"
            :search="search"
          />
        </v-col>
        <Dialogbox
          @closing="closing"
          @deleteuser="deleteQuestion"
          :title="dialogboxtitle"
          :dialog="dialogstatus"
          :buttonTitle="dialogButtontitle"
          :deleteuser="true"
          v-if="dialogstatus"
        />
      </v-row>
    </v-container>
    <v-btn dark fab fixed bottom right large color="pink" class="mx-2" v-if="canAdd" @click="addQuestion">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </v-content>
</template>

<script>
import { mapGetters } from "vuex"
import store from "@/store"
import {
  FETCH_QUESTION,
  DELETE_QUESTION,
  RESET_STATE
} from "@/store/actions.type";
import { SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type"
export default {
  name: "Questions",
  beforeRouteEnter(to, from, next) {
    store.dispatch(RESET_STATE)
    store.dispatch(FETCH_QUESTION, "").then(resp => {
      if (resp.success) {
        store.commit(SET_LOADING, false)
        store.commit(SET_ROUTER_ENTER, false)
      }
    });
    return next();
  },
  beforeRouteLeave(to, from, next) {
    store.dispatch(RESET_STATE)
    next();
  },
  data: function() {
    return {
      title: "Questions",
      search: "",
      dialogstatus: false,
      dialogButtontitle: null,
      dialogboxtitle: null,
      questionid: null,
      singleSelect: "",
      dialog: false,
    };
  },
  components: {
    DataTable: () => import("@/components/datatable/datatable"),
    Dialogbox: () => import("@/components/dialog/dialog"),
    Header: () => import("@/components/header/Header")
  },
  computed: {
    ...mapGetters(["questions",'currentUser']),
    headers () {
      return [
        { text: this.$t("Question id"), value: "question_id" },  
        { text: this.$t("Name"), value: "question_name" },        
        { text: this.$t("Type"), value: "question_type" },        
        { text: this.$t("Question"), value: "question_text" },        
        { text: this.$t("Language"), value: "question_lang_label" },        
        { text: this.$t("Actions"), value: "action", sortable: false }
      ]
    },
    canAdd(){
      if(typeof (this.currentUser) !== 'undefined') {
        if(this.currentUser.permissions.includes('can-create-question') || this.currentUser.roles.includes(1)){
          return true;
        }
      }
      return false;
    }
  },
  methods: {
    addQuestion() {
      this.$router.push("/questions/add");
    },
    editing(id) {
      this.$router.push("/questions/edit/" + id)
    },
    deleting(id) {
      this.dialogstatus = true
      this.dialogboxtitle = "Are you sure want to remove?"
      this.dialogButtontitle = "Remove"
      this.questionid = id
    },
    async deleteQuestion() {
      await this.$store
        .dispatch(DELETE_QUESTION, this.questionid)
        .then(async resp => {
          if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
            this.questionid = null;
            await store.dispatch(FETCH_QUESTION, "").then(resp => {
              if (resp.success) {
                store.commit(SET_LOADING, false);
                this.dialogstatus = false;
              }
            });
          }
          else{
            store.commit(SET_LOADING, false);
          }
        });
    },
    closing() {
      this.dialogstatus = false
    },
  }
};
</script>